<div class="progress-bar-background">
    <div class="progress-bar" [style.width]="getProgressBarWidth()" [style.backgroundColor]="getProgressBarColor()"></div>
    <div class="goal-percentage">{{getProgressPercentage()}}</div>
</div>
